import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Autocomplete, Checkbox, Chip, FormControlLabel, FormGroup, Grid2, MenuItem, Select, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useDispatch, useSelector } from 'react-redux';
import { getQuoteByServiceId } from '../../redux/Slice/quoteSlice';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs({services,modifyServices, setModifyServices}) {

  const [value, setValue] = React.useState(null);

  const dispatch = useDispatch();

  const { quotes} = useSelector((state) => state.quote);
  const templateOptions = quotes?.filter((quote) => quote.status);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleServiceChange = (va, index) =>{
    if(modifyServices.some(gh=> gh?.serviceId === va?._id)){
        setModifyServices(modifyServices.filter(gh=> gh?.serviceId !== va?._id))
        setValue(null)
    }
    else{
        setModifyServices([...modifyServices, {
            serviceId: va?._id,
            features: va?.features,
            template:[]
        }])
        setValue(index);
        dispatch(getQuoteByServiceId({q_id: va?._id }))
    }
  }

  const updateFeatureValue = (featureId, newValue) => {
    setModifyServices((prevData) =>
      prevData.map((item) => ({
        ...item,
        features: item.features.map((feature) =>
          feature.key === featureId ? { ...feature, value: newValue } : feature
        ),
      }))
    );
  };

  const updateTemplates = (serviceId, newValue) => {
    console.log(serviceId, newValue)
    setModifyServices((prevData) =>
      prevData.map((item) =>
        item.serviceId === serviceId
          ? { ...item, template: newValue.map(gh => gh._id) }
          : item
      )
    );
  };

  return (
    <Grid2 container spacing={1}
    >
        <Grid2 size={0.5}>
        <FormGroup>
    {services?.map((va, index)=>(
        <FormControlLabel control={<Checkbox 
        checked={modifyServices.some(ab => ab.serviceId === va._id)}
        onChange={()=>handleServiceChange(va, index)}
        inputProps={{ 'aria-label': 'controlled' }}  
        />} />
    ))}
  
    </FormGroup>
        </Grid2>
        <Grid2 size={2.5}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
      {services?.map((va, index)=>(
        <Tab onClick={()=> dispatch(getQuoteByServiceId({q_id: va?._id }))} label={va?.name} disabled={!modifyServices.some(ab => ab.serviceId === va._id)} {...a11yProps(index)} />
      ))}
      </Tabs>
      </Grid2>
      <Grid2 size={9}>
      {services?.map((va, ind)=>(
      <TabPanel value={value} index={ind}>
      <Grid2 container spacing={2} width={'100%'}>
      <Grid2 size={6}>
                    <Box display="flex" flexDirection="column" gap={2} padding={2} sx={{border: "1px solid #ddd", borderRadius: 2}}>
                       <Typography variant="h6" style={{ marginBottom: '1px' }}>
                         Features
                         </Typography>
                        {va.features.map((feature, index) => (
                       <Box key={index} display="flex" alignItems="center" gap={1}>
                       <Typography width={'60%'} variant="body1" style={{ marginRight: '8px' }}>
                        {feature.key}:
                       </Typography>

      <TextField
        variant="outlined"
        size="small"
        value={modifyServices?.filter(bc=> bc.serviceId === va._id)[0]?.features[index]?.value}
        onChange={(e) => updateFeatureValue(feature.key, e.target.value)}
        style={{ flex: 1 }}
      />
  </Box>
))}

                         

                 </Box>
                 </Grid2>
            <Grid2 size={6}>
                 <Box padding={2} sx={{border: "1px solid #ddd", borderRadius: 2}}>
                 <Typography variant="h6" style={{ marginBottom: '15px' }}>Select Templates</Typography>
                 <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={templateOptions}
      disableCloseOnSelect
      sx={{height:'100%'}}
      getOptionLabel={(option) => option?.templateName}
      value={
  templateOptions.filter(option =>
    (modifyServices.find(bc => bc.serviceId === va._id)?.template || []).includes(option._id)
  ) || []
}
        onChange={(event, newValue) => {
            updateTemplates(va._id, newValue)
        }}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.templateName}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder='Select Template'/>
      )}
    />
</Box>
</Grid2>
</Grid2>
      </TabPanel>
      ))}
      </Grid2>
    </Grid2>
  );
}
